var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"align-center":"","justify-center":"","pt-0":"","pl-0":"","pr-0":"","pb-0":""}},[_c('ComponentProject',{on:{"activeMenu":_vm.activeMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }